// import { useAuth0 } from "@auth0/auth0-react";
import axios from 'axios';
import { API_BASE_URL, API_URL } from './constants';

export const MULTIPART_FORM_DATA_HEADER = {
  headers: { 'Content-Type': 'multipart/form-data' },
};

const getRemoteUrl = (url, useAbsoluteUrl = false) => {
  const trimmed = url.startsWith('/') ? url.substring(1) : url;
  return useAbsoluteUrl
    ? `${API_URL}/${trimmed}`
    : `${API_BASE_URL}/${trimmed}`;
};

// export const useAxiosInterceptor = () => {
//   const { getAccessTokenSilently } = useAuth0();
//   const authHeaderInterceptor = async (request) => {
//     if (request.url.startsWith(API_BASE_URL)) {
//       try {
//         const token = await getAccessTokenSilently();
//         // eslint-disable-next-line no-param-reassign
//         request.headers.common.Authorization = `Bearer ${token}`;
//       } catch (error) {
//         // nothing to do here
//       }
//     }
//     return request;
//   }

//   // Add a request interceptor
//   // this is hackish and uses axios private APIs. But there is no other better way to ensure that the interceptor is added only once
//   if (!axios.interceptors.request.handlers.some(handler => handler.fulfilled?.name === authHeaderInterceptor.name)) {
//     axios.interceptors.request.use(authHeaderInterceptor);
//   }
// }

export const requestGet = async (
  url,
  params,
  useAbsoluteUrl = false,
  cancelToken = null
) => {
  try {
    const response = await axios.get(getRemoteUrl(url, useAbsoluteUrl), {
      params,
      cancelToken,
    });
    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      return { canceled: true };
    }
    console.log(error);
    return {
      errored: true,
      error: error.response,
      code: error.response?.status,
      message: error.response?.data?.message,
    };
  }
};

export const requestPost = async (url, data, headers) => {
  try {
    const response = await axios.post(
      getRemoteUrl(url),
      data || {},
      headers || {}
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return { errored: true, error: error.response };
  }
};

export const requestPut = async (url, data, config) => {
  try {
    const response = await axios.put(getRemoteUrl(url), data, config || {});
    return response.data;
  } catch (error) {
    console.error(error);
    return { errored: true, error: error.response };
  }
};

export const requestDelete = async (url, headers = {}) => {
  try {
    const response = await axios.delete(getRemoteUrl(url), headers);
    return response.data;
  } catch (error) {
    console.error(error);
    return { errored: true, error: error.response };
  }
};

export const requestImageUpload = async (file, type) => {
  const formData = new FormData();
  formData.append('file', file);
  return requestPost(
    `users/me/attachment/image?type${type}`,
    formData,
    MULTIPART_FORM_DATA_HEADER
  );
};

export const requestFileDownload = async (url, fileName) => {
  const response = await axios.get(url, { responseType: 'blob' });
  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};
